import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import MobileRestrictionScreen from './MobileRestrictionScreen';

// Screen breakpoint for mobile restriction
export const MOBILE_BREAKPOINT = 640;

// Mobile Navigation Items
export const MOBILE_NAV_ITEMS = [
  { path: '/dashboard', label: 'Dashboard', icon: '📊' },
  { path: '/training', label: 'Training', icon: '📚' },
  { path: '/testing', label: 'Testing', icon: '🧪' },
  { path: '/settings', label: 'Settings', icon: '⚙️' },
];

const MobileLayout = ({ 
  pageTitle,
  restrictionTitle,
  restrictionMessage,
  restrictionFeatures,
  restrictionProTip
}) => {
  const navigate = useNavigate();
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);

  // Mobile Sidebar Component
  const MobileSidebar = () => (
    <div className={`fixed inset-y-0 left-0 w-64 bg-white shadow-xl transform transition-transform duration-300 ease-in-out z-[10000] ${showMobileSidebar ? 'translate-x-0' : '-translate-x-full'}`}>
      <div className="p-4 border-b">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-800">Menu</h2>
          <button
            onClick={() => setShowMobileSidebar(false)}
            className="p-2 rounded-full hover:bg-gray-100"
          >
            <FiX className="w-6 h-6" />
          </button>
        </div>
      </div>
      <nav className="p-4">
        {MOBILE_NAV_ITEMS.map((item) => (
          <button
            key={item.path}
            onClick={() => {
              navigate(item.path);
              setShowMobileSidebar(false);
            }}
            className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-100 mb-2 text-left"
          >
            <span className="text-xl">{item.icon}</span>
            <span className="text-gray-700">{item.label}</span>
          </button>
        ))}
      </nav>
    </div>
  );

  // Mobile Header
  const MobileHeader = () => (
    <div className="fixed top-0 left-0 right-0 bg-white border-b z-[9999] px-4 py-3">
      <div className="flex items-center justify-between">
        <button
          onClick={() => setShowMobileSidebar(true)}
          className="p-2 rounded-full hover:bg-gray-100"
        >
          <FiMenu className="w-6 h-6" />
        </button>
        <h1 className="text-lg font-semibold">{pageTitle}</h1>
        <div className="w-8" /> {/* Spacer for alignment */}
      </div>
    </div>
  );

  // Mobile Overlay
  const MobileOverlay = () => (
    showMobileSidebar && (
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-[9999]"
        onClick={() => setShowMobileSidebar(false)}
      />
    )
  );

  return (
    <>
      <MobileHeader />
      <MobileSidebar />
      <MobileOverlay />
      <div className="fixed inset-0 w-full h-full bg-white z-[9998] pt-16 overflow-y-auto">
        <div className="w-full max-w-2xl px-4 mx-auto py-6">
          <MobileRestrictionScreen 
            title={restrictionTitle}
            message={restrictionMessage}
            features={restrictionFeatures}
            proTip={restrictionProTip}
          />
        </div>
      </div>
    </>
  );
};

export default MobileLayout; 